import axios from 'axios';
import { RequestHandler } from '../../app/RequestHandler';

export type Translations = Record<string, string>;

export async function getTranslations(): Promise<Translations> {
  const { language, country } = new RequestHandler();

  const url = `/eac/${language}_${country}/flowrate-calculation-backend/translationText`;

  const options = {
    headers: {
      'Content-Type': `application/json`,
    },
  };

  const { data } = await axios.get<Translations>(url, options);

  return data;
}
